<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
	addVoucher,
	updateVoucher,
	checkVoucherValidation,
	getAllVouchers,
	deleteVoucher,
	getVoucherS3URL,
} from "../../../api/services/voucher.service";
import { newVoucherObject } from "./voucher-controller";
import generateVoucherSuccessModel from "./success-voucher";
import voucherValidityResultModel from "./voucher-validity-result";

/**
 * Manage Vouchers Page
 */
export default {
	page: {
		title: "Gutscheine Verwalten",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
		"generate-voucher-success-model": generateVoucherSuccessModel,
		"voucher-validity-result-model": voucherValidityResultModel,
	},
	data() {
		return {
			title: this.$i18n.t("vouchers.header.title"),
			items: [
				{
					text: this.$i18n.t("vouchers.header.item"),
					active: true,
				},
			],
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: "number",
			sortDesc: false,
			fields: [
				{
					key: "id",
					label: "",
					sortable: true,
					thClass: "d-none",
					tdClass: "d-none",
				},
				{
					key: "code",
					label: "Code",
					sortable: false,
				},
				{
					key: "purchaserName",
					label: this.$i18n.t("vouchers.table.purchaserName"),
					sortable: true,
				},
				{
					key: "purchaserEmail",
					label: this.$i18n.t("vouchers.table.purchaserEmail"),
					sortable: true,
				},
				{
					key: "Betrag",
					lable: this.$i18n.t("vouchers.table.amount"),
					sortable: true,
				},
				{
					key: "paymentId",
					lable: this.$i18n.t("vouchers.table.paymentId"),
				},
				{
					key: "status",
					label: this.$i18n.t("vouchers.table.status"),
					sortable: true,
				},
				{
					key: "voucherS3URL",
					label: "",
					sortable: false,
					thClass: "d-none",
					tdClass: "d-none",
				},
				{
					key: "statusAction",
					label: "",
					sortable: false,
				},
			],
			voucherGenerationProcessing: false,
			allVochers: null,
			dataForTable: [],
			generatedVoucherAmount: null,
			generateVoucherAmountMissing: false,
			showGenerateVoucherSuccessModel: false,
			voucherAmountToSend: null,
			voucherCodeToSend: null,
			voucherURLToSend: null,
			showVoucherValidityResultModel: false,
			voucherCodeToValidate: null,
			voucherCodeMissing: false,
			voucherValidityToPass: null,
			voucherStatusToPass: null,
			deleteVocuherFailed: false,
			deleteVoucherSuccess: false,
			voucherUpdateSuccess: false,
			voucherUpdateFailed: false,
		};
	},
	computed: {
		/**
		 * Total no. of records
		 */
		rows() {
			return this.dataForTable.length;
		},
	},
	async mounted() {
		// Set the initial number of items
		this.totalRows = this.items.length;
		await this.getAllVouchers();
	},
	methods: {
		async getAllVouchers() {
			let getAllVouchersFunction = await getAllVouchers();
			this.allVochers = getAllVouchersFunction;

			for (let i = 0; i < this.allVochers.length; i++) {
				let voucher_push = {
					id: "",
					number: 0,
					code: "",
					purchaserName: "",
					purchaserEmail: "",
					Betrag: 0,
					paymentId: "-",
					status: "",
					voucherS3URL: "",
					statusAction: "",
				};

				voucher_push.id = this.allVochers[i].id;
				voucher_push.number = i + 1;
				voucher_push.code = this.allVochers[i].code;
				voucher_push.purchaserName = this.allVochers[i].purchaserName;
				voucher_push.purchaserEmail = this.allVochers[i].purchaserEmail;
				voucher_push.Betrag = this.allVochers[i].value;
				voucher_push.status = this.allVochers[i].status;
				voucher_push.voucherS3URL = this.allVochers[i].voucherS3URL;
				voucher_push.statusAction = this.allVochers[i].status;
				const paymentId = this.allVochers[i].paymentId;
				if (paymentId === "") {
					voucher_push.paymentId = "-";
				} else {
					voucher_push.paymentId = paymentId;
				}

				this.dataForTable.push(voucher_push);
			}
		},
		async clickVoucherValidity() {
			if (this.voucherCodeToValidate) {
				let getVoucherValidityResult = await checkVoucherValidation(
					this.voucherCodeToValidate
				);

				if (getVoucherValidityResult) {
					this.voucherValidityToPass = getVoucherValidityResult.valid;
					this.voucherStatusToPass = getVoucherValidityResult.status;
					this.showVoucherValidityResultModel = true;
				}
			} else {
				this.voucherCodeMissing = true;
			}
		},
		async clickGenerateVouchers() {
			if (this.generatedVoucherAmount > 0) {
				this.voucherGenerationProcessing = true;
				this.generateVoucherAmountMissing = false;

				let newVoucherObject_Pass = new newVoucherObject();
				newVoucherObject_Pass.voucherValue = Number(
					this.generatedVoucherAmount
				);

				let getGeneratedVoucher = await addVoucher(newVoucherObject_Pass);

				if (getGeneratedVoucher.id) {
					let voucherLink = await getVoucherS3URL(getGeneratedVoucher.id);
					this.voucherURLToSend = voucherLink.downloadURL;
				}

				if (getGeneratedVoucher) {
					let getUpdatedVoucher = await updateVoucher(
						getGeneratedVoucher.id,
						"AVAILABLE"
					);

					if (getUpdatedVoucher) {
						this.voucherAmountToSend = getUpdatedVoucher.value;
						this.voucherCodeToSend = getUpdatedVoucher.code;
						this.voucherGenerationProcessing = false;
						this.showGenerateVoucherSuccessModel = true;
					}
				}
			} else {
				this.generateVoucherAmountMissing = true;
			}
		},
		realodPage() {
			window.location.reload();
		},
		openVoucher(record) {
			let selectedVoucher = record;
			this.voucherAmountToSend = selectedVoucher.amount;
			this.voucherCodeToSend = selectedVoucher.code;
			this.showGenerateVoucherSuccessModel = true;
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		async deleteVoucher(voucherId) {
			let deleteVoucherSuccess = await deleteVoucher(voucherId);

			if (deleteVoucherSuccess) {
				this.deleteVoucherSuccess = true;
				this.realodPage();
			} else {
				this.deleteVocuherFailed = true;
			}
		},
		async makeVoucherAvailable(voucherId) {
			let makeVoucherAvailableSuccess = await updateVoucher(
				voucherId,
				"AVAILABLE"
			);

			if (makeVoucherAvailableSuccess.status === "AVAILABLE") {
				this.voucherUpdateSuccess = true;
				this.realodPage();
			} else {
				this.voucherUpdateFailed = true;
			}
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<!-- Check Voucher Validity Card -->
			<div class="col-lg-6 col-xl-6">
				<b-card>
					<b-card-title>
						<h5 class="card-title">{{ $t("vouchers.validity.title") }}</h5>
					</b-card-title>
					<b-card-text>
						{{ $t("vouchers.validity.description") }}
					</b-card-text>
					<div class="row">
						<div class="col-md-8">
							<b-form-group>
								<b-form-input
									v-model="voucherCodeToValidate"
									:placeholder="this.$i18n.t('vouchers.validity.placeholder')"
								></b-form-input>
								<small v-if="this.voucherCodeMissing" class="text-danger">{{
									$t("vouchers.validity.vocuherCodeMissing")
								}}</small>
							</b-form-group>
						</div>
						<div class="col-md-4">
							<b-button @click="clickVoucherValidity()" variant="warning">
								<i class="bx bxs-check-circle mr-1"></i>
								{{ $t("vouchers.validity.button") }}</b-button
							>
						</div>
					</div>
				</b-card>
			</div>
			<!-- Grnarate Vouchers Card -->
			<div class="col-lg-6 col-xl-6">
				<b-card>
					<b-card-title>
						<h5 class="card-title">{{ $t("vouchers.generate.title") }}</h5>
					</b-card-title>
					<b-card-text>
						{{ $t("vouchers.generate.description") }}
					</b-card-text>
					<div class="row">
						<div class="col-md-12">
							<b-alert v-model="voucherGenerationProcessing" variant="info"
								><i class="bx bx-loader-alt bx-spin mr-2"></i
								>{{ $t("vouchers.generate.processing") }}</b-alert
							>
						</div>
					</div>
					<div class="row pt-3">
						<div class="col-md-7 col-xl-7">
							<b-form-group>
								<b-form-input
									v-model="generatedVoucherAmount"
									type="number"
									:placeholder="this.$i18n.t('vouchers.generate.placeholder')"
								></b-form-input>
								<small
									v-if="this.generateVoucherAmountMissing"
									class="text-danger"
								>
									{{ $t("vouchers.generate.voucherAmountMissing") }}
								</small>
							</b-form-group>
						</div>
						<div class="col-md-5 col-xl-5">
							<b-button @click="clickGenerateVouchers()" variant="success">
								<i class="bx bxs-coupon mr-1"></i>
								{{ $t("vouchers.generate.button") }}</b-button
							>
						</div>
					</div>
				</b-card>
			</div>
		</div>
		<!-- end row -->
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-md-6">
								<h4 class="card-title">{{ $t("vouchers.table.topic") }}</h4>
							</div>
							<div class="col-md-6">
								<b-alert
									v-model="deleteVocuherFailed"
									variant="danger"
									dismissible
									><i class="bx bx-error-circle mr-2"></i
									>{{ $t("vouchers.delete.failedMsg") }}</b-alert
								>
								<b-alert
									v-model="deleteVoucherSuccess"
									variant="success"
									dismissible
									><i class="mdi mdi-check-all mr-2"></i
									>{{ $t("vouchers.delete.successMsg") }}</b-alert
								>
								<b-alert
									v-model="voucherUpdateFailed"
									variant="danger"
									dismissible
									><i class="bx bx-error-circle mr-2"></i
									>{{ $t("vouchers.validity.voucherUpdatedFailed") }}</b-alert
								>
								<b-alert
									v-model="voucherUpdateSuccess"
									variant="success"
									dismissible
									><i class="mdi mdi-check-all mr-2"></i
									>{{
										$t("vouchers.validity.voucherUpdatedSuccessfully")
									}}</b-alert
								>
							</div>
						</div>
						<div class="row mt-4 mb-4">
							<div class="col-sm-12 col-md-6">
								<div id="tickets-table_length" class="dataTables_length">
									<label class="d-inline-flex align-items-center">
										Anzeigen&nbsp;
										<b-form-select
											v-model="perPage"
											size="sm"
											:options="pageOptions"
										></b-form-select
										>&nbsp;Einträge
									</label>
								</div>
							</div>
							<!-- Search -->
							<div class="col-sm-12 col-md-6">
								<div
									id="tickets-table_filter"
									class="dataTables_filter text-md-right"
								>
									<label class="d-inline-flex align-items-center">
										Suchen:
										<b-form-input
											v-model="filter"
											type="search"
											placeholder="Suchen..."
											class="form-control form-control-sm ml-2"
										></b-form-input>
									</label>
								</div>
							</div>
							<!-- End search -->
						</div>
						<!-- Table -->
						<div class="table-responsive mb-0">
							<b-table
								:items="dataForTable"
								:fields="fields"
								responsive="sm"
								:per-page="perPage"
								:current-page="currentPage"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:filter="filter"
								:filter-included-fields="filterOn"
								@filtered="onFiltered"
							>
								<template v-slot:cell(Betrag)="data">
									<small> EUR </small> {{ data.value.toLocaleString("de") }}
								</template>
								<template v-slot:cell(status)="data">
									<span
										class="badge badge-soft-secondary font-size-12"
										:class="{
											'badge-soft-success': `${data.value}` === 'AVAILABLE',
											'badge-soft-danger': `${data.value}` === 'USED',
											'badge-soft-info': `${data.value}` === 'NOTACTIVE',
											'badge-soft-warning': `${data.value}` === 'CLOSED',
										}"
									>
										<span v-if="data.value === 'AVAILABLE'">
											{{ $t("vouchers.status.available") }}
										</span>
										<span v-if="data.value === 'USED'">
											{{ $t("vouchers.status.used") }}
										</span>
										<span v-if="data.value === 'NOTACTIVE'">
											{{ $t("vouchers.status.notActive") }}
										</span>
										<span v-if="data.value === 'CLOSED'">
											{{ $t("vouchers.status.close") }}
										</span>
									</span>
								</template>
								<template v-slot:cell(voucherS3URL)="data">
									<div class="text-right">
										<a :href="data.value" target="_blank"
											><b-button variant="primary" size="sm"
												><i class="bx bxs-download"></i></b-button
										></a>
									</div>
								</template>
								<template v-slot:cell(statusAction)="scope">
									<div class="text-right">
										<span v-if="scope.item.statusAction === 'NOTACTIVE'">
											<b-button
												variant="success"
												size="sm"
												@click="makeVoucherAvailable(scope.item.id)"
												><i class="bx bxs-check-circle"></i
											></b-button>
										</span>
										<span v-else-if="scope.item.statusAction === 'AVAILABLE'">
											<a :href="scope.item.voucherS3URL" target="_blank"
												><b-button variant="primary" class="ml-2" size="sm"
													><i class="bx bxs-download"></i></b-button
											></a>
										</span>
										&nbsp;
										<span>
											<b-button
												variant="danger"
												size="sm"
												@click="deleteVoucher(scope.item.id)"
												><i class="bx bx-trash"></i
											></b-button>
										</span>
									</div>
								</template>
							</b-table>
						</div>
						<div class="row">
							<div class="col">
								<div
									class="dataTables_paginate paging_simple_numbers float-right"
								>
									<ul class="pagination pagination-rounded mb-0">
										<!-- pagination -->
										<b-pagination
											v-model="currentPage"
											:total-rows="rows"
											:per-page="perPage"
										></b-pagination>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- end row -->

		<!-- Generate Voucher Success Model-->
		<generate-voucher-success-model
			v-if="showGenerateVoucherSuccessModel === true"
			:visible="showGenerateVoucherSuccessModel"
			@close="showGenerateVoucherSuccessModel = false"
			@reload="realodPage()"
			:voucherAmount="voucherAmountToSend"
			:voucherCode="voucherCodeToSend"
			:voucherURL="voucherURLToSend"
		/>

		<!-- Voucher Validity Result Model -->
		<voucher-validity-result-model
			v-if="showVoucherValidityResultModel === true"
			:visible="showVoucherValidityResultModel"
			@close="showVoucherValidityResultModel = false"
			@reload="realodPage()"
			:voucherValid="voucherValidityToPass"
			:voucherStatus="voucherStatusToPass"
		/>
	</Layout>
</template>
